import { createStore } from 'vuex'

export default createStore({
  state: {
    showPopup: false,
    showPopup360: false,
    popupType: null,
    selected: null,
    selectedIndex: null,
    selectedRoute: "route-1",
    shipArea: 2,
    shipHover: null,
    objects: [
      {
        id: "id00",
        title: "Dutch East India Company",
        description: "This was the first large modern company in the world. It had stocks, thousands of employees and operated in many countries. Vereenigde Oostindische Compagnie (VOC) is the company's name in Dutch.",
        icon: "voc-logo"
      },
      {
        id: "id01",
        title: "Pepper",
        description: "Pepper is a tiny dried fruit. It was used to make food taste better, used as medicine, and to flavour wine. Pepper was the most popular spice the VOC traded.",
        icon: "pepper",
        comesFrom: "Came from Indonesia",
        row: 1
      },
      {
        id: "id02",
        title: "Nutmeg",
        description: "Nutmeg is the dried seed of a fruit. The seed is ground down into powder and used in food, to flavour wine, and to treat any sickness from a cold to the plague!",
        icon: "nutmeg",
        comesFrom: "Came from Indonesia",
        row: 1
      },
      {
        id: "id03",
        title: "Mace",
        description: "Mace is the red dried outer covering of nutmeg fruits. It was used mostly in food, but also to treat sickness like nausea, indigestion, rashes, even anxiety!",
        icon: "mace",
        comesFrom: "Came from Indonesia",
        row: 1
      },
      {
        id: "id04",
        title: "Cardamon",
        description: "Cardamon is made from green dried seeds. It was used in food, to give wine a warm flavour, and to treat indigestion, asthma and bad breath.",
        icon: "cardamon",
        comesFrom: "Came from Sri Lanka",
        row: 1
      },
      {
        id: "id05",
        title: "Tulips",
        description: "Tulips are colourful flowers that bloom in spring. In the 1630s they became popular for wealthy Dutch people, with a few tulips costing the price of a house!",
        icon: "tulips",
        comesFrom: "Came from Turkey",
        row: 1
      },
      {
        id: "id06",
        title: "Porcelain",
        description: "Porcelain is a type of pottery originating in China. It is notable for its delicacy and strength as well as it’s bright white colour which made it expensive.",
        icon: "porcelain",
        comesFrom: "Came from China and Japan",
        row: 1
      },
      {
        id: "id07",
        title: "Sugar",
        description: "Sugar was grown in China and Indonesia. It has been popular for thousands of years and keeps food fresh for longer. Europeans thought it cured colds and cleaned blood.",
        icon: "sugar",
        comesFrom: "Came from China and Indonesia",
        row: 1
      },
      {
        id: "id08",
        title: "Luxury Goods",
        description: "Luxury Goods like umbrellas, carpets, pearls and incense were shipped from all over Asia. Before the VOC, these goods were moved in long journeys over land.",
        icon: "luxury-goods",
        comesFrom: "Came from China and Japan",
        row: 1
      },
      {
        id: "id09",
        title: "Silver",
        description: "Silver was the main way the VOC traded with other countries. It was used across the world as money, but was also used to make everyday items like spoons.",
        icon: "silver",
        comesFrom: "Came from The Netherlands",
        row: 2
      },
      {
        id: "id10",
        title: "Cloves",
        description: "Cloves are dried flower buds. They were used in food and to treat illness like toothache and memory loss. Europeans also used cloves to hide bad smells.",
        icon: "cloves",
        comesFrom: "Came from Indonesia",
        row: 2
      },
      {
        id: "id11",
        title: "Gemstones",
        description: "Gemstones like emeralds, diamonds and rubies were considered exotic. They were valuable in trade and were usually made into jewellery with silver or gold.",
        icon: "gemstones",
        comesFrom: "Came from Sri Lanka and India",
        row: 2
      },
      {
        id: "id12",
        title: "Cinnamon",
        description: "Cinnamon is the dried bark of a tree. It was often used as a perfume, to add a warm flavour to food, to treat fever or cramps and to help digestion.",
        icon: "cinnamon",
        comesFrom: "Came from Sri Lanka",
        row: 2
      },
      {
        id: "id13",
        title: "Yarn",
        description: "Yarn could be made of cotton, wool, or other materials. It was used by the Dutch to make fabric, clothing, rope and was used in embroidery and knitting.",
        icon: "yarn",
        comesFrom: "Came from India and Turkey",
        row: 2
      },
      {
        id: "id14",
        title: "Copper",
        description: "Copper is a very useful metal. The Dutch used copper to make roofs for houses and pots for cooking. It's also used to make bronze, which is used in coins and guns.",
        icon: "copper",
        comesFrom: "Came from Japan",
        row: 2
      },
      {
        id: "id15",
        title: "Silk",
        description: "Silk thread is produced by many kinds of insects and is woven into soft fabrics. Its shiny smooth texture and high price made silk a luxury.",
        icon: "silk",
        comesFrom: "Came from Arabia, India and China",
        row: 2
      },
      {
        id: "id16",
        title: "Star Anise",
        description: "Star Anise is a seed pod that's been used as a medicine and spice for thousands of years. It's also used in jams, syrups and puddings because of its sweet flavour.",
        icon: "star-anise",
        comesFrom: "Came from China and Japan",
        row: 2
      },
      {
        id: "id17",
        title: "Tea",
        description: "Tea was first transported to Europe by the Dutch. It was originally used as a medicine to treat kidney stones and help circulation, as well as a way to show off wealth.",
        icon: "tea",
        comesFrom: "Came from China and Japan",
        row: 3
      },
      {
        id: "id18",
        title: "Coffee",
        description: "Coffee is made from seeds that are roasted and used to make the popular drink. It was often used to help people concentrate or to treat gout, a form of severe pain.",
        icon: "coffee",
        comesFrom: "Came from Indonesia",
        row: 3
      },
      {
        id: "id19",
        title: "Ivory",
        description: "Ivory was made from the tusks of animals, usually elephants. They were used in art sculptures, as well as to decorate furniture and sometimes for medicine.",
        icon: "ivory",
        comesFrom: "Came from West Africa",
        row: 3
      },
      {
        id: "id20",
        title: "Lacquer",
        description: "Lacquer is made from black tree resin. Wooden objects like furniture, utensils and crockery were coated in lacquer to make them hard, smooth and shiny.",
        icon: "lacquer",
        comesFrom: "Came from Japan",
        row: 3
      },
      {
        id: "id21",
        title: "Gold",
        description: "Gold is a rare metal that was used to make guilder coins for the VOC. It was also used in jewellery and for decoration in furniture and ceramics.",
        icon: "gold",
        comesFrom: "Came from West Africa and Japan",
        row: 3
      },
      {
        id: "id22",
        title: "Cloth",
        description: "The Dutch took a lot of cloth back to the Netherlands for use in their clothing and furniture industries. Cloth was also often traded for slaves in West Africa.",
        icon: "cloth",
        comesFrom: "Came from India",
        row: 3
      },
      {
        id: "id23",
        title: "Areca Nuts",
        description: "Areca Nuts are used in medicine, but they're also very addictive, like smoking. If they're misused, they can cause harmful effects on longterm health!",
        icon: "areca-nuts",
        comesFrom: "Came from Sri Lanka and China",
        row: 3
      },
      {
        id: "id24",
        title: "Slaves",
        description: "Slaves were a major part of the VOC. People were taken from their countries and sold to wealthy people as slaves. Over 200 years the VOC traded over 500,000 slaves.",
        icon: "slaves",
        comesFrom: "People who lived in West Africa",
        row: 3
      }
    ],
    locations: [
      {
        id: "loc00",
        title: "The Netherlands",
        description: "The Dutch traded many things all over the world! They brought their traded goods back home to the Netherlands, which made both the country and its people very rich.",
        icon: "popup-flag netherlands",
        knownFor: "the spice trade",
        x: "614",
        y: "236",
        active: ['route-1', 'route-2', 'route-3', 'route-4', 'route-5', 'route-6', 'route-7', 'route-8'],
        largeMarker: 1
      },
      {
        id: "loc01",
        title: "Cape Town",
        description: "At Cape Town in South Africa, Dutch sailors could relax and take a short break while they restocked their ships with food, water and other supplies for their long sea voyages.",
        icon: "popup-flag cape-town",
        knownFor: "restocking supplies",
        x: "705",
        y: "805",
        active: ['route-1', 'route-2', 'route-3', 'route-4', 'route-5', 'route-6', 'route-7', 'route-8']
      },
      {
        id: "loc02",
        title: "Sri Lanka",
        description: "Sri Lanka is an island just south of India. The Dutch traded cardamon and cinnamon from Sri Lanka every year. It was the largest cinnamon grower in the world!",
        icon: "popup-flag sri-lanka",
        knownFor: "cardamon, cinnamon and areca nuts",
        x: "1083",
        y: "555",
        active: ['route-1', 'route-2', 'route-3', 'route-4', 'route-5', 'route-6', 'route-7', 'route-8']
      },
      {
        id: "loc03",
        title: "Indonesia",
        description: "Indonesia is made up of thousands of islands. The VOC was based in Batavia (now called Jakarta) on the main island of the country. Indonesia was known for growing a variety of spices across its islands.",
        icon: "popup-flag indonesia",
        knownFor: "pepper, cloves and coffee",
        x: "1249",
        y: "630",
        active: ['route-1', 'route-2', 'route-3', 'route-4', 'route-5', 'route-6', 'route-7', 'route-8'],
        largeMarker: 4
      },
      {
        id: "loc04",
        title: "Malaku",
        description: "Malaku is a large group of islands in eastern Indonesia that used to be called the 'Spice Islands'. The VOC controlled these islands where nutmeg and mace were grown.",
        icon: "popup-flag malaku",
        knownFor: "nutmeg and mace",
        x: "1371",
        y: "601",
        active: ['route-5', 'route-6', 'route-7', 'route-8']
      },
      {
        id: "loc05",
        title: "Wik Country",
        description: "Thewena (also known as Cape Keerweer) is on Wik Country on the west coast of Cape York Peninsula. It is where the Duyfken turned back after a conflict with the Wik people who had lived there for many thousands of years.",
        icon: "popup-flag wik-country",
        knownFor: "",
        x: "1452",
        y: "683",
        active: ['route-2']
      },
      {
        id: "loc06",
        title: "Arabia",
        description: "Arabia is a peninsula next to Egypt. The VOC bought silk from the region, which had been trading the fabric for hundreds of years.",
        icon: "popup-flag arabia",
        knownFor: "silk and coffee",
        x: "896",
        y: "459",
        active: ['route-5', 'route-6', 'route-7']
      },
      {
        id: "loc07",
        title: "India",
        description: "India had been trading with Europeans for hundreds of years before the VOC came. They traded silk, yarn and precious gemstones with the Dutch.",
        icon: "popup-flag india",
        knownFor: "silk, yarn, gemstones and cloth",
        x: "1051",
        y: "442",
        active: ['route-5', 'route-6', 'route-7']
      },
      {
        id: "loc08",
        title: "China",
        description: "China is a large country in Asia. It had lots of goods that the VOC wanted to trade, such as tea, porcelain, silk and sugar.",
        icon: "popup-flag china",
        knownFor: "tea, porcelain, silk, sugar and star anise",
        x: "1252",
        y: "405",
        active: ['route-5', 'route-6']
      },
      {
        id: "loc09",
        title: "Japan",
        description: "Japan is east of China. The Dutch were the only people allowed to trade with Japan, which had silver, lacquer and copper.",
        icon: "popup-flag japan",
        knownFor: "luxury goods, copper and lacquer",
        x: "1387",
        y: "375",
        active: ['route-5', 'route-6', 'route-7', 'route-8']
      },
      {
        id: "loc10",
        title: "Western Australia",
        description: "The VOC were the first European company to make maps of the west and north coasts of Australia. Many ships ran aground here after being blown off course by the trade winds (also known as the Roaring Forties)",
        icon: "popup-flag western-australia",
        knownFor: "",
        x: "1290",
        y: "760",
        active: ['route-3']
      }
    ]
  },
  getters: {
    getPopupType(state) {
      return state.popupType
    },
    getShowPopup(state) {
      return state.showPopup
    },
    getShowPopup360(state) {
      return state.showPopup360
    },
    getSelected(state) {
      return state.selected
    },
    getSelectedIndex(state) {
      return state.selectedIndex
    },
    getSelectedLocationIndex(state) {
      return state.selectedLocationIndex
    },
    getSelectedRoute(state) {
      return state.selectedRoute;
    },
    getShipArea(state) {
      return state.shipArea;
    },
    getShipHover(state) {
      return state.shipHover;
    },
    getShipAreas(state) {
      return state.shipAreas
    },
    getObjects(state) {
      return state.objects
    },
    getLocations(state) {
      return state.locations
    }
  },
  mutations: {
    setPopupType(state, payload) {
      state.popupType = payload
    },
    setShowPopup(state, payload) {
      state.showPopup = payload
    },
    setSelected(state, payload) {
      state.selected = payload
    },
    setSelectedIndex(state, payload) {
      state.selectedIndex = payload
      state.popupType = "itemsTrade"
      state.selected = state.objects[payload]
    },
    setSelectedLocationIndex(state, payload) {
      state.selectedLocationIndex = payload
      state.popupType = "locations"
      state.selected = state.locations[payload]
    },
    setSelectedItemID(state, payload) {
      state.popupType = "items360"
      state.selected = state.items360[payload]
    },
    setSelectedRoute(state, route) {
      state.selectedRoute = route;
    },
    setShipArea(state, payload) {
      state.shipArea = payload;
      state.shipHover = null
    },
    setShipHoverArea(state, payload) {
      state.shipHoverArea = payload;
      if (!isNaN(payload)) {
        state.shipHover = state.shipAreas[payload]
      } else {
        state.shipHover = null
      }
    },
    setShipHover(state, payload) {
      state.shipHover = payload;
    }
  },
  actions: {
    nextItem({ commit, getters }) {
      let start = 1
      let index = (getters.getSelectedIndex + 1) % getters.getObjects.length
      index = Math.max(index,start)
      commit("setSelectedIndex", index)
    },
    previousItem({ commit, getters }) {
      let start = 1
      let index = (getters.getSelectedIndex - 1 + getters.getObjects.length) % getters.getObjects.length
      if (index < start) {
        index = getters.getObjects.length - 1
      }
      commit("setSelectedIndex", index)
    },
    nextLocation({ commit, getters }) {
      let index = (getters.getSelectedLocationIndex + 1) % getters.getLocations.length
      commit("setSelectedLocationIndex", index)
    },
    previousLocation({ commit, getters }) {
      let index = (getters.getSelectedLocationIndex - 1 + getters.getLocations.length) % getters.getLocations.length
      commit("setSelectedLocationIndex", index)
    }
  },
  modules: {}
})